import { render, staticRenderFns } from "./SubAccountDetails.vue?vue&type=template&id=4952c1cc"
import script from "./SubAccountDetails.vue?vue&type=script&lang=ts"
export * from "./SubAccountDetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports